module.exports = __webpack_public_path__ + "static/media/press_content_06.28a1c8d5.png";